<template>
  <v-footer class="footer-pjh" padless>
    <v-container class="footer-inner">
      <!-- Top row -->
      <v-row class="footer-top" align="start" no-gutters>
        <!-- Logo -->
        <v-col cols="12" md="3" class="footer-brand">
          <img :src="getThemeImage('logo_footer2')" alt="Hidalgo" class="footer-logo"/>
        </v-col>

        <!-- Phones -->
        <v-col cols="12" md="6" class="footer-phones">
          <div class="phones-grid">
            <div class="phone-item">
              <div class="phone-num">911</div>
              <div class="phone-label">Emergencia</div>
            </div>

            <div class="phone-item">
              <div class="phone-num">089</div>
              <div class="phone-label">Denuncia Anónima</div>
            </div>

            <div class="phone-item">
              <div class="phone-num">070</div>
              <div class="phone-label">Atención Ciudadana</div>
            </div>

            <div class="phone-item">
              <div class="phone-num">71 73242</div>
              <div class="phone-label">Barandilla</div>
            </div>

            <div class="phone-item">
              <div class="phone-num">71 79063</div>
              <div class="phone-label">Ministerio</div>
            </div>
          </div>
        </v-col>

        <!-- Links + Address -->
        <v-col cols="12" md="3" class="footer-links">
          <a href="#" class="footer-link">Aviso de privacidad</a>
          <a href="#" class="footer-link">Términos y Condiciones</a>
          <a href="#" class="footer-link">Contacto</a>

          <div class="footer-address">
            <div>Plaza Juárez s/n Col.Centro</div>
            <div>Pachuca de Soto, Hidalgo,</div>
            <div>México</div>
          </div>
        </v-col>
      </v-row>

      <!-- Divider -->
      <div class="footer-divider"></div>

      <!-- Bottom row -->
      <v-row class="footer-bottom" align="center" no-gutters>
        <v-col cols="12" md="8" class="footer-copy">
          Copyrights © 2022 Todos los derechos reservados por Hidalgo de la Transformación
        </v-col>

        <v-col cols="12" md="4" class="footer-social">
          <a href="#" aria-label="Facebook" class="social-btn">
            <v-icon class="social-ico">mdi-facebook</v-icon>
          </a>

          <a href="#" aria-label="Instagram" class="social-btn">
            <v-icon class="social-ico">mdi-instagram</v-icon>
          </a>

          <a href="#" aria-label="X" class="social-btn">
            <v-icon class="social-ico">mdi-twitter</v-icon>
          </a>

          <a href="#" aria-label="Google" class="social-btn">
            <v-icon class="social-ico">mdi-google</v-icon>
          </a>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<style scoped>
.footer-pjh {
  width: 100%;
  color: #fff !important;

  /* 2 capas en 1 solo background (NO se pisan) */
  background-image: url("~@/assets/img/frame_footer.svg"),
  linear-gradient(178deg, #641232 0%, #831C3F 100%) !important;

  background-repeat: no-repeat, no-repeat !important;
  background-position: center bottom, center center !important;
  background-size: cover, cover !important;

  /* opacidad SOLO para el SVG (truco: filtro) */
  /* Si quieres más tenue, usa opacity con un overlay (ver opción B) */
  position: relative;
  overflow: hidden;
}


/* contenido arriba */
.footer-pjh .footer-inner {
  position: relative;
  z-index: 1;
}


/* Top grid */
.footer-top {
  row-gap: 24px;
}

.footer-brand {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.footer-logo {
  width: 210px;
  max-width: 100%;
  height: auto;
  object-fit: contain;
}

/* Phones */
.footer-phones {
  display: flex;
  justify-content: center;
}

.phones-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 22px;
  justify-items: center;
  text-align: center;
}

.phone-num {
  font-weight: 900;
  font-size: 16px;
  letter-spacing: 0.2px;
  margin-bottom: 4px;
}

.phone-label {
  font-size: 13px;
  opacity: 0.92;
}

/* Links */
.footer-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
}

.footer-link {
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.95;
}

.footer-link:hover {
  text-decoration: underline;
}

.footer-address {
  margin-top: 10px;
  font-size: 13px;
  line-height: 1.35;
  opacity: 0.92;
}

/* Divider + bottom */
.footer-divider {
  margin: 26px 0 18px;
  height: 1px;
  background: rgba(255, 255, 255, 0.45);
}

.footer-bottom {
  row-gap: 14px;
}

.footer-copy {
  font-size: 14px;
  opacity: 0.95;
}

.footer-social {
  display: flex;
  justify-content: flex-end;
  gap: 14px;
}

.social-btn {
  width: 30px;
  height: 30px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.10);
  text-decoration: none;
}

.social-btn:hover {
  background: rgba(255, 255, 255, 0.18);
}

/* Responsive */
@media (max-width: 960px) {
  .footer-brand {
    justify-content: center;
  }

  .footer-links {
    align-items: center;
    text-align: center;
  }

  .footer-social {
    justify-content: center;
  }

  .phones-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }
}

.social-ico{
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
  color: #fff !important;
}

</style>

<script>
export default {

  computed: {
    getThemeImage() {
      return (key) => {
        const themeIcons = this.$vuetify.theme.themes.light?.icons;
        if (!themeIcons || !themeIcons[key]) {
          console.warn(` La clave "${key}" no existe en los iconos del tema.`);
          return ""; // Retorna una imagen vacía en caso de error
        }

        const path = themeIcons[key];

        try {
          return require(`@/assets/${path}`);
        } catch (error) {
          console.error(`⚠️ Error al cargar la imagen: ${path}`, error);
          return ""; // Retorna una imagen vacía en caso de error
        }
      };
    },
  },
};

</script>
